import { useEffect } from 'react'
import { SelectInput } from '../../SelectInput/index.js'
import { capitalize, splitByUppercase } from '../../../utils/text.js'

// export type SchemaEnum = Prop<{
//     type?: 'enum';
//     default?: EnumItem | undefined;
//     enum: EnumItem[];
// }>;
// type EnumItem = string | number | boolean;

export const EnumType = ({ value, onChange, schemaProp, name, disabled }) => {
  const {
    title,
    description,
    readOnly,
    enum: enums,
    default: defaultValue,
  } = schemaProp

  let newEnums = []

  for (let i = 0; i < enums?.length; i++) {
    newEnums.push({ label: enums[i], value: enums[i] })
  }

  return (
    <SelectInput
      options={newEnums}
      value={value || defaultValue}
      onChange={(v) => {
        if (onChange) {
          onChange(v, name)
        }
      }}
      label={capitalize(splitByUppercase(title ?? name))}
      description={description}
      disabled={readOnly || disabled}
    />
  )
}
